import { EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Modal } from 'antd';
import confirm from 'antd/lib/modal/confirm';
import { useNavigate } from 'react-router-dom';
import {
  approveConsigmentOrder,
  deleteItemModal,
  modalButtons,
  noApproveConsigmentOrder,
  notDeleteableStatus,
  roleConst,
  UrlPaths,
} from '../../../../constants';
import { consignmentOrderTableOpt } from '../../../../constants/ConsignOrder.const';
import { filterOptionsConst } from '../../../../constants/FilterOptions';
import { useDispatch } from 'react-redux';
import { getConsignmentOrderMovements } from '../../../../appRedux/actions';

export const ConsignOrderTableOptions = ({
  id = null,
  path = null,
  action = {},
  finished = false,
  status = '',
  privileges = [],
  role = null,
  approved = false,
  numberOrder = null,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { onDelete } = !!action && action;

  const handleApprove = async (id) => {
    const response = await dispatch(getConsignmentOrderMovements(id));

    const movements = response?.data || [];

    if (!movements.length) {
      Modal.confirm({
        title: noApproveConsigmentOrder.title,
        content: noApproveConsigmentOrder.body,
        okType: 'danger',
        okText: modalButtons.confirm,
        cancelText: modalButtons.cancel,
      });
      return;
    }

    const isValid = movements.every((item) => {
      const consigned = Number(item.consignedQuantity);
      const billed = Number(item.totalBilled);
      const refunded = Number(item.totalRefunded);

      return consigned === billed + refunded;
    });

    if (!isValid) {
      Modal.confirm({
        title: noApproveConsigmentOrder.title,
        content: noApproveConsigmentOrder.body,
        okType: 'danger',
        okText: modalButtons.confirm,
        cancelText: modalButtons.cancel,
      });
      return;
    }

    confirm({
      title: approveConsigmentOrder.title,
      icon: <ExclamationCircleOutlined />,
      content: approveConsigmentOrder.body,
      okText: modalButtons.confirm,
      cancelText: modalButtons.cancel,
      onOk() {
        return new Promise((resolve) => {
          setTimeout(() => {
            action?.onApprove?.action(...action.onApprove.params);
            resolve();
          }, 500);
        });
      },
    });
  };

  let options = consignmentOrderTableOpt().filter((opt) =>
    privileges.includes(opt.privilege)
  );

  if (approved && !finished && roleConst.branchManager === role) {
    options.push({
      label: 'Editar',
      key: 'edit',
      icon: <EditOutlined />,
      privilege: 'edit',
    });
  }

  if (notDeleteableStatus.includes(status) || finished) {
    options = options.filter((opt) => opt.key !== filterOptionsConst.DELETE);
  }

  const renderMenu = (id) => {
    return (
      <Menu onClick={({ key }) => handleMenuClick(key, id)} items={options} />
    );
  };

  const handleMenuClick = (key, id) => {
    switch (key) {
      case 'edit':
        navigate(`/dashboard/${path}/${id}`);
        break;
      case 'delete':
        showDeleteConfirm();
        break;
      case 'invoice':
        navigate(UrlPaths.CONSIGNMENT_ORDER_BILLING(id, numberOrder));
        break;
      case 'refund':
        navigate(UrlPaths.CONSIGNMENT_ORDER_REFUND(id, numberOrder));
        break;
      case 'approve':
        handleApprove(id);
        break;
      default:
        break;
    }
  };

  const showDeleteConfirm = () => {
    confirm({
      title: deleteItemModal.title,
      icon: <ExclamationCircleOutlined />,
      content: deleteItemModal.body,
      okType: 'danger',
      okText: modalButtons.confirm,
      cancelText: modalButtons.cancel,
      onOk() {
        return new Promise((resolve) => {
          setTimeout(resolve(onDelete.action(...onDelete.params)), 1000);
        });
      },
      onCancel() {},
    });
  };

  return (
    <Dropdown.Button
      disabled={!(options.length > 0)}
      overlay={renderMenu(id)}
      trigger={['click']}
      placement="bottom"
    />
  );
};
